import axios from '@/axios'

export default {
	namespaced: true,

	actions: {
		fetchAll({ commit }, { fromDate, toDate, type: workType, page, perPage }) {
			return axios.get('/materialJournal/filterWork', {
				params: {
					fromDate,
					toDate,
					workType,
					sortByCreatedAt: true,
					Isposted: true,
					page,
					perPage
				}
			})
		},

		create({ commit }, { date, workType, workItemRequests }) {
			/* workItemRequests = [
				quantity
				ownerId
				lot
				itemId
				date
				notes
			] */
			return axios.post('/materialJournal/work', { date, workType, workItemRequests })
		},

		update({ commit }, { id, date, workType, workItemRequests }) {
			/* workItemRequests = [
				quantity
				ownerId
				lot
				itemId
				date
				notes
			] */
			return axios.put(`/materialJournal/work/${id}`, { date, workType, workItemRequests })
		},

		delete({ commit }, { id }) {
			return axios.delete(`/materialJournal/work/${id}`)
		}
	},
}